// Vendor scripts
import 'bootstrap';

// Alertbar
import './scripts/banner-dismiss';

// Custom scripts
window.initMap = require('./scripts/map').default;
import './scripts/resizing-scripts';
import './scripts/image-widget';
import './scripts/swiper-config';
import './scripts/dropdown-links';
import './scripts/animate-stats';
import './scripts/accordion';
import './scripts/form-label'
import './scripts/submenu-links';
